import { Highlight } from 'react-instantsearch-dom'
import classNames from 'classnames'

const type = (hit) => {
  if (hit.answer) return 'Answered question'
  if (hit.content_type === 'question') return 'Question'
  if (hit.content_type === 'article') return 'Article'
  if (hit.content_type === 'ideation') return 'Idea'
  if (hit.content_type === 'event') return 'Event'
  return 'Discussion'
}

const HitContainerControl = ({ inputValue, hits, highlightedIndex, getItemProps, style, exclude, searchById, finalInput }) =>
  <div key='results' className='algolia-hit-container' style={style}>
    {inputValue && !hits.length
      ? (
        <div className='algolia-hit-container__header'>
          <span className='algolia-hit-container__header-text'>
            No result found for:
          </span>
          {' '}
          {inputValue}
        </div>)
      : null}
    <ul className='algolia-search-results'>
      {
        hits.filter(hit => {
          if (!searchById) return hit

          return hit.id === parseInt(finalInput) || hit.private_id === parseInt(finalInput)
        }).map((hit, index) => {
          const disabled = typeof exclude !== 'undefined' && Array.isArray(exclude) && (exclude.includes(hit.id) || exclude.includes(hit.private_id))
          return (
            <li
              key={hit.id}
              className={classNames(
                'algolia-search-result',
                { disabled: disabled },
                { highlighted: highlightedIndex === index }
              )}
              {...getItemProps({ item: hit, index: index, disabled: disabled })}
            >
              <span className='algolia-hit-item'>
                <Highlight attribute='title' hit={hit} tagName='strong' /><br />
                <span>{type(hit)} by {hit.username}</span>
              </span>
            </li>
          )
        })
      }
    </ul>
  </div>

export default HitContainerControl
